module.exports = __webpack_public_path__ + "static/media/a.a3732964.png";